module.exports = __webpack_public_path__ + "img/rank_b.ac21a0b6.png";